const BomLibraryType = {
  FETCH_BOM_LIBARARY: 'FETCH_BOM_LIBARARY',
  FETCH_REFERENCE_TYPE: 'FETCH_REFERENCE_TYPE',
  FETCH_USERS: 'FETCH_USERS',
  FETCH_REFERENCE_SUPPLIER: 'FETCH_REFERENCE_SUPPLIER',
  FETCH_COMPOSITION: 'FETCH_COMPOSITION',
  FETCH_UNIT_OF_MEASURE: 'FETCH_UNIT_OF_MEASURE',
  FETCH_SUPPLIERS: 'FETCH_SUPPLIERS',
  ADD_BOM_LIBARARY: 'ADD_BOM_LIBARARY',
  GET_BOM_LIBARARY: 'GET_BOM_LIBARARY',
  DELETE_BOM_LIBARAY: 'DELETE_BOM_LIBARAY',
  FETCH_SEASON: 'FETCH_SEASON',
  FETCH_CATEGORY_ONE: 'FETCH_CATEGORY_ONE',
  FETCH_CATEGORY_TWO: 'FETCH_CATEGORY_TWO',
  FETCH_CATEGORY_THREE: 'FETCH_CATEGORY_THREE',
  GET_BOM_LIBARARY_WITHOUT_PAGINATE: 'GET_BOM_LIBARARY_WITHOUT_PAGINATE',
  GET_BOM_LIBARARY_WITH_SORT: 'GET_BOM_LIBARARY_WITH_SORT',
  BOM_LIBARARY_EMPTY: 'BOM_LIBARARY_EMPTY',
  BOM_SUPPLIER: 'BOM_SUPPLIER',
  SEARCH_BOM_LIBARARY: 'SEARCH_BOM_LIBARARY',
  EDIT_BOM_LIBARARY: 'EDIT_BOM_LIBARARY',
  FETCH_COLOUR_DOC: 'FETCH_COLOUR_DOC',
  FETCH_CATEGORY1: 'FETCH_CATEGORY1',
  FETCH_CATEGORY2: 'FETCH_CATEGORY2',
  FETCH_CATEGORY3: 'FETCH_CATEGORY3',
  FETCH_CATEGORY4: 'FETCH_CATEGORY4',
  ADD_BOM_LIBARARY_TAGS: 'ADD_BOM_LIBARARY_TAGS',
  GET_BOM_LIBARARY_TAGS: 'GET_BOM_LIBARARY_TAGS',
  GET_BOM_LIBARARYBYID_TAGS: 'GET_BOM_LIBARARYBYID_TAGS',
  FETCH_SUPPLIER_FACTORIES: 'FETCH_SUPPLIER_FACTORIES',
  UPDATE_EXCEL_DATA: 'UPDATE_EXCEL_DATA',
  CLEAR_DATA: 'CLEAR_DATA',
  GET_ALL_BOM_OPTIONS: 'GET_ALL_BOM_OPTIONS',
  FETCH_BOM_SUB_COMPONENT_TYPE: 'FETCH_BOM_SUB_COMPONENT_TYPE',
  FETCH_BOM_SUB_LIST_COMPONENT_TYPE: 'FETCH_BOM_SUB_LIST_COMPONENT_TYPE',
};

export default BomLibraryType;
